export const SOCIAL_PREVIEW_EXCERPT_MAX_LENGTH = 80;

export function markdownToPlainText(input = "") {
  return String(input || "")
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/\[([^\]]+)\]\([^)]*\)/g, "$1")
    .replace(/<https?:\/\/[^>]+>/gi, "")
    .replace(/https?:\/\/[^\s<>()]+/gi, "")
    .replace(/^\s*(`{3,}|~{3,})(?:\w+)?\s*$/gm, "")
    .replace(/^\s{0,3}(?:#{1,6}|>|[-+*]|\d+[.)])\s+/gm, "")
    .replace(/~~([^~]+)~~/g, "$1")
    .replace(/\*\*([^*]+)\*\*/g, "$1")
    .replace(/__([^_]+)__/g, "$1")
    .replace(/([*_`])([^\n]+?)\1/g, "$2")
    .replace(/<[^>]+>/g, " ")
    .replace(/\\([\\`*_{}\[\]()#+.!>-])/g, "$1")
    .replace(/\s+/g, " ")
    .trim();
}

export function buildPlainTextSnippet(input, maxLen = 140) {
  const plainText = markdownToPlainText(input);
  if (!plainText || plainText.length <= maxLen) return plainText;
  const bounded = plainText.slice(0, maxLen).trim();
  const wordBoundary = bounded.replace(/\s+\S*$/, "").trim();
  return `${wordBoundary || bounded.trim()}…`;
}

export function buildShareAttribution(authorName, spaceName) {
  const author = String(authorName || "A member").trim() || "A member";
  const space = String(spaceName || "Sproutly").trim() || "Sproutly";
  return `Posted by ${author} on ${space}`;
}
